<template>
  <div class="add-form">
    <div class="back-title">
      <span @click="onCancel"><i class="el-icon-back" /> 返回上一级</span>
    </div>

    <div class="form-title">
      <span v-if="pid">{{ form.realname }} 的个人信息</span>
      <span v-else>新增用户</span>
    </div>

    <el-form ref="form"
             :model="form"
             :rules="rules"
             label-width="120px"
             label-position="left">
      <el-form-item label="姓名"
                    prop="realname">
        <el-input v-model.trim="form.realname" />
      </el-form-item>
      <el-form-item label="用户编号"
                    prop="user_id">
        <el-input v-model.trim="form.user_id" />
      </el-form-item>
      <el-form-item label="用户名"
                    prop="name">
        <el-input v-model.trim="form.name" />
      </el-form-item>
      <template v-if="pid">
        <el-form-item label="密码" prop="password_hash">
          <el-input v-model="form.password_hash"
                    placeholder="6-16 位由数字字母（大小写都有）和特殊符号组成"
                    type="password"
                    autocomplete="new-password" />
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="密码"
                      prop="password_hash">
          <el-input v-model="form.password_hash"
                    placeholder="6-16 位由数字字母（大小写都有）和特殊符号组成"
                    type="password"
                    autocomplete="new-password" />
        </el-form-item>
      </template>
      <el-form-item label="电子邮件"
                    prop="email">
        <el-input v-model.trim="form.email" />
      </el-form-item>
      <el-form-item label="手机号"
                    prop="phone">
        <el-input v-model.trim="form.phone" />
      </el-form-item>
      <el-form-item label="所属人事组"
                    style="width:315px;"
                    prop="department">
        <el-input v-model="form.department" />
      </el-form-item>
      <el-form-item label="所属用户组"
                    prop="user_group_id">
        <el-select v-model="form.user_group_id"
                   placeholder="请选择">
          <el-option v-for="u in userGroups"
                     :key="u.id"
                     :label="u.name"
                     :value="u.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="所属权限组"
                    prop="auth_group_ids">
        <el-checkbox-group v-model="form.auth_group_ids">
          <el-checkbox v-for="u in authGroups"
                       :key="u.id"
                       :label="u.id">
            {{ u.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   @click="onSubmit">
          提交
        </el-button>
        <el-button @click="onCancel">
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  addUser, updateUser, queryUserInfo, queryUserGroup, queryAuthGroup,
} from '@/api/admin';
import systemConfig from '@/config';

export default {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    pid: {
      default: null,
    },
    pageProps: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value && !/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-z0-9A-Z]).{6,16}$/.test(value)) {
        callback(new Error('6-16 位由数字字母（大小写都有）和特殊符号组成'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (value && !/^1[35678]\d{9}$/.test(value)) {
        callback(new Error('填入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      query: {
        page: 1,
        per_page: 10000,
      },
      form: {
        auth_group_ids: [],
      },
      userGroups: [],
      authGroups: [],
      rules: {
        realname: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 50, message: '1~50任意字符', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { max: 50, message: '1~50任意字符', trigger: 'blur' },
        ],
        password_hash: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        email: [
          { max: 50, message: '不能超过50字符', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur'] },
        ],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' },
        ],

        department: [{ required: true, message: '请选择人事组', trigger: 'blur' }],
        user_group_id: [{ required: true, message: '请选择用户组', trigger: 'blur' }],
        auth_group_ids: [{ required: true, message: '请选择权限组', trigger: 'blur' }],
        password2: [{ required: true, message: '请输入确认密码', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters(['stores']),
  },
  mounted() {
    this.getAllUserGroups();
    this.getAllAuthGroups();
    if (this.pid) {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      const params = { id: this.pid };
      queryUserInfo(params).then((res) => {
        if (res.data) {
          const result = res.data;
          result.user_group_id = result.user_groups.id;
          result.auth_group_ids = result.auth_groups.map(item => item.id);
          if (Object.prototype.hasOwnProperty.call(result, 'name')) {
            delete result.auth_groups;
          }
          this.form = result;
        }
      });
    },
    getAllUserGroups() {
      const params = Object.assign({}, this.query);
      params.query_filters = {};
      queryUserGroup(params).then((res) => {
        this.userGroups = res.data.groups;
      });
    },
    getAllAuthGroups() {
      const params = Object.assign({}, this.query);
      params.query_filters = {};
      queryAuthGroup(params).then((res) => {
        this.authGroups = res.data.groups;
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.form);
          Object.keys(params).forEach((k) => {
            if (!params[k]) {
              delete params[k];
            }
          });
          if (this.pid) {
            updateUser(params).then((res) => {
              this.onCancel();
              this.$store.dispatch('GetInfo');
            });
          } else {
            addUser(params).then((res) => {
              this.onCancel();
              this.$store.dispatch('GetInfo');
            });
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    onCancel() {
      this.$emit('setRPQ', { r: 'list', p: undefined });
    },
  },
};
</script>
